import { getReportType } from 'reporting-data/tsTypes/reportTypes';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import memoize from 'transmute/memoize';
import { isUnifiedResolveSupportedReportType } from './UnifiedReportResolver';
const UNKNOWN = 'unknown';
export const getValidatedReportTrackingInfo = memoize(report => {
  const reportType = getReportType(report);
  const isUnifiedVizSupportedReportType = isUnifiedResolveSupportedReportType(report);
  const chartType = getReportChartType(report);
  return {
    reportType,
    isUnifiedVizSupportedReportType,
    chartType: chartType !== null && chartType !== void 0 ? chartType : UNKNOWN
  };
});